import styled from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled.div`
	flex: 1;
	width: 100%;
	height: 100%;
`;

export const Content = styled.div`
	flex: 1;
  display: flex;
	// width: 100%;
	// height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 3.42rem;
  // margin-left: 4.4rem;
  // padding: 1rem 1.5rem 5rem;
	padding: 4rem 1.5rem 5rem 5.5rem;
	
	// 767px
  @media (max-width: 47.9375rem) {
		padding: 4rem 0.5rem 5rem;
  }
`;

export const Header = styled.div`
  display: flex;
	// flex-direction: column;
	justify-content: space-between;
  width: 100%;
  // margin-bottom: 20px;
	// border: 2px solid blue;

  h1 {
		font-size: 20px;
		font-weight: 500;
		text-overflow: ellipsis;
	}

	h2 {
		font-size: 20px;
		font-weight: 500;
		color: #607d8b;
		text-overflow: ellipsis;
	}

	button {
		display: flex;
		align-items: center;
    font-weight: 600;
    border-radius: 8px;
    padding: 6px 20px;
		// height: 60%;
    // margin: 5px 10px;

		background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

		:hover {
			background: #1565C0;
			border: 1px solid #1565C0;
		}

		:focus {
			background: #1565C0;
			border: 1px solid #1565C0;
		}

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

	// 767px
  @media (max-width: 47.9375rem) {
		button {
			font-size: 12px;
		}
	}
	// 557px
  @media (max-width: 34.8125rem) {
		button {
			padding: 6px 12px;
			svg {
				font-size: 18px;
			}
		}
  };
	// 479px
  @media (max-width: 29.9375rem) {
		margin-bottom: 10px;

		h1 {
			font-size: 18px;
		}

		h2 {
			font-size: 16px;
		}

		button {
			font-size: 12px;
			padding: 4px 10px;
		}
	}
`;

export const Filtros = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
	padding: 5px 10px 10px;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
	border-radius: 8px;
	margin-bottom: 20px;

	// 991px
  @media (max-width: 61.9375rem) {
    width: 100%
  }
`;

export const FormView = styled(Form)`
  display: flex;
  align-items: center;
	// border: 2px solid violet;

	.input-content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;

		margin-right: 10px;

		:last-child {
			margin-right: 0;
		}

		span {
			font-size: 0.9375rem; // 15px
			font-weight: 500;
			color: #455a64;
		}
	}

	.input-content-button {
		margin-left: 10px;
	}

	.radio-group {
		display: flex;
		flex-direction: column;
		padding: 5px;
		margin-right: 10px;
		border: 1px solid #d1d2dc;
		border-radius: 8px;
		
		.radio-label {
			display: flex;
			align-items: center;
			margin: 0;

			input[type='radio'] {
				margin-right: 0.625rem; // 10px;
				appearance: none;
				font: inherit;
				color: var(--azul-razio);
				width: 1.125rem; // 18px;
				height: 1.125rem; // 18px;
				border: 2px solid var(--gray-border-lw);
				border-radius: 50%;

				:checked {
					border: 5px solid var(--azul-razio);
				}
			}

			label {
				font-size: 0.9375rem; // 15px
				font-weight: 500;
				color: #455a64;
			}
		};
  };

	button {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #1a83ff;
		color: #fff;
		font-weight: 600;
		border-radius: 8px;
		padding: 7px 30px;

		svg {
			font-size: 20px;
			margin-right: 10px;
		}
	}

	// 767px
  @media (max-width: 47.9375rem) {
    flex-direction: column;
		width: 80%;

		button {
			margin-top: 0;
		};

		.radio-group {
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			padding: 2px 20px !important;
			width: 100%;

			.radio-label {
				display: flex;
				align-items: center;

				input[type='radio'] {
					margin-right: 0.2rem;
				}

				label {
					margin-right: 0.625rem; // 10px;
				}
			};
		};
  };
	// 557px
  @media (max-width: 34.8125rem) {
		width: 100% !important;
		padding: 0 5px;
  };
	// 479px
  @media (max-width: 29.9375rem) {
		.input-content {
			div {
				padding: 2px 5px !important;

				input {
					// height: 25px;
					font-size: 13px;
				}
				// max-width: 190px;
			}
		};

		.radio-group {
			padding: 2px 5px !important;
		};
		
		button {
			padding: 5px 20px;
			svg {
				margin-right: 0;
			}
			span {
				display: none;
				visibility: hidden;
			}
		};
  };
`;

export const ListVazio = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;